import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert";
import { Tabs, Tab } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import Pagination from "react-js-pagination";
import {
  fetchDashboardNotificationList,
  searchDashboardNotificationList,
  resetPushNotifications,
  outreachCreateModal,
} from "DashboardOutreachAction";
import { fetchCategoryWiseUser, fetchEventDetails } from "DashboardUserAction";
import {
  COMMON_FAIL_MESSAGE,
  itemCount,
  screenHeightLeftFromTop,
} from "Constants";
import Loader from "Loader";
import DashboardOutreachCreate from "./dashboard-outreach-create";
import DashboardOutreachView from "./dashboard-outreach-view";
import DashboardNotificationItem from "./dashboard-notification-item";
import DashboardScheduledNotificationItem from "./dashboard-scheduled-notificationlist";
import LocaleStrings from "Languages";

class Outreach extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1,
      search: "",
      resetBtnLoader: false,
      selectedTab: 1,
    };
  }

  componentDidMount() {
    this.props.fetchDashboardNotificationList(
      this.props.session,
      0,
      (res) => {}
    );

    this.props.fetchCategoryWiseUser(this.props.session);
    this.props.fetchEventDetails(this.props.session);
  }

  open = () => {
    this.props.outreachCreateModal({ show: true });
  };

  additionCallback = () => {
    this.paginationCallback(this.state.pageNumber);
  };

  onSearch = (event) => {
    var search = event.target.value;
    let pageNumber = 1;

    this.finalApiCall(pageNumber, search);
    this.setState({ search, pageNumber });
  };

  paginationCallback = (pageNumber) => {
    var { search } = this.state;

    this.finalApiCall(pageNumber, search);
    this.setState({ pageNumber });
  };

  finalApiCall = (pageNumber, search = "") => {
    if (search === "") {
      this.props.fetchDashboardNotificationList(this.props.session, pageNumber);
    } else {
      this.props.searchDashboardNotificationList(
        this.props.session,
        pageNumber,
        search
      );
    }
  };

  handleTabs = (key) => {
    this.setState({ selectedTab: key });
  };

  resetNotifications = () => {
    if (this.props.notifcationList.resource.length > 0) {
      confirmAlert({
        title: LocaleStrings.outreach_table_reset_btn_text,
        message: LocaleStrings.outreach_table_reset_alert_text,
        confirmLabel: LocaleStrings.button_ok,
        cancelLabel: LocaleStrings.button_cancel,
        buttons: [
          {
            label: LocaleStrings.button_ok,
            onClick: () => {
              this.setState({ resetBtnLoader: true });
              this.props.resetPushNotifications(
                this.props.session,
                (callback) => {
                  this.setState({ resetBtnLoader: false });
                  if (callback.error === 0) {
                    this.props.showSuccess(
                      LocaleStrings.outreach_reset_push_notification_success
                    );
                    this.finalApiCall(1, "");
                  } else {
                    this.props.showError(COMMON_FAIL_MESSAGE);
                  }
                }
              );
            },
          },
          {
            label: LocaleStrings.button_cancel,
            onClick: () => {},
          },
        ],
      });
    } else {
      this.props.showError(
        LocaleStrings.outreach_reset_push_notification_error
      );
    }
  };

  renderList() {
    let pageDataLength = this.props.notifcationList.resource.length;
    let { pageNumber } = this.state;

    return _.map(this.props.notifcationList.resource, (notification, index) => {
      return (
        <DashboardNotificationItem
          key={`push_key_${index}`}
          notification={notification}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
          pagination={this.paginationCallback}
        />
      );
    });
  }

  renderscheduledList() {
    let pageDataLength = this.props.notifcationscheduledList.resource.length;
    let { pageNumber } = this.state;

    return _.map(
      this.props.notifcationscheduledList.resource,
      (notification, index) => {
        return (
          <DashboardScheduledNotificationItem
            key={`schedule_push_key_${index}`}
            notification={notification}
            pageDataLength={pageDataLength}
            currentPage={pageNumber}
            pagination={this.paginationCallback}
          />
        );
      }
    );
  }

  /**
   * =============================================================================================
   */

  render() {
    let {
      deviceSize,
      notifcationList,
      notifcationscheduledList,
      DashboardNotificationModal,
      DashboardNotificationViewModal,
      eventDetails,
    } = this.props;
    let { search, selectedTab, pageNumber } = this.state;

    // console.log(
    //   "notifcationList, notifcationscheduledList :- ",
    //   notifcationList,
    //   notifcationscheduledList
    // );

    let curTimezone = "";
    let eventtimezone = "";
    if (Object.keys(eventDetails).length > 0) {
      curTimezone = moment()
        .tz(this.props.eventDetails.eventtimezone)
        .format("Z z");
      eventtimezone = this.props.eventDetails.eventtimezone;
    }

    return (
      <div className="panel noborder-panel">
        <div className="content-header-bar">
          <div className="vertical-align-center">
            <input
              className="form-control mapsearch"
              placeholder={LocaleStrings.outreach_search_ph}
              type="text"
              value={search}
              onChange={this.onSearch}
            />
          </div>

          <ul className="header-buttons">
            {selectedTab == 1 ? (
              <li>
                <Button
                  type="button"
                  className="btn btn-custom-white btn"
                  title="Press Me"
                  onClick={this.resetNotifications}
                  disabled={this.state.resetBtnLoader}
                >
                  {this.state.resetBtnLoader ? (
                    <span>
                      <i
                        className="fa fa-spinner icn-spinner"
                        aria-hidden="true"
                        style={{ paddingRight: 4 }}
                      ></i>{" "}
                      {LocaleStrings.outreach_table_reset_btn_text}
                    </span>
                  ) : (
                    <span>
                      <i
                        className="fa fa-refresh"
                        aria-hidden="true"
                        style={{ paddingRight: 4 }}
                      ></i>{" "}
                      {LocaleStrings.outreach_table_reset_btn_text}
                    </span>
                  )}
                </Button>
              </li>
            ) : (
              ""
            )}
            <li>
              <button
                type="button"
                className="btn btn-custom-blue"
                onClick={this.open}
              >
                <img
                  style={{ paddingRight: 8, paddingBottom: 3 }}
                  src="../../style/images/header-icons/plus.png"
                  alt="plus"
                />
                {LocaleStrings.button_create_new}
              </button>
            </li>
          </ul>
        </div>

        <div
          className="panel-body scrollable-content outreach-tabs"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          {notifcationList && notifcationList.resource ? (
            <Tabs activeKey={selectedTab} onSelect={this.handleTabs}>
              <Tab
                eventKey={1}
                title={LocaleStrings.outreach_notification_tab1}
              >
                {notifcationList.resource.length > 0 ? (
                  <div
                    className="scrollable-content-without-height"
                    style={{ height: deviceSize.height - 236 }}
                  >
                    <div className="outreach-right-content-">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>{LocaleStrings.outreach_table_list_posts}</th>
                            <th>
                              {LocaleStrings.outreach_table_list_linked_with}
                            </th>
                            <th>
                              {LocaleStrings.outreach_table_list_recipients}
                            </th>
                            <th>
                              {LocaleStrings.outreach_table_list_read_count}
                            </th>
                            <th>
                              {LocaleStrings.outreach_table_list_read_rate}
                            </th>
                            <th>{LocaleStrings.outreach_table_list_action}</th>
                          </tr>
                        </thead>
                        <tbody className="tbody-background">
                          {this.renderList()}
                        </tbody>
                      </table>
                    </div>

                    <div className="outreach-right-content-pagination-">
                      {notifcationList && notifcationList.count > itemCount ? (
                        <Pagination
                          activePage={pageNumber}
                          itemsCountPerPage={itemCount}
                          totalItemsCount={notifcationList.count}
                          pageRangeDisplayed={10}
                          onChange={this.paginationCallback}
                          style={{ float: "right" }}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="nooutreach-info">
                    <span>
                      {LocaleStrings.outreach_text_no_notification_added}
                      <br /> {LocaleStrings.outreach_text_add_to_appear}
                    </span>
                  </div>
                )}
              </Tab>
              <Tab
                eventKey={2}
                title={LocaleStrings.outreach_notification_tab2}
              >
                {notifcationscheduledList.resource.length > 0 ? (
                  <div
                    className="scrollable-content-without-height"
                    style={{ height: deviceSize.height - 236 }}
                  >
                    <div className="text-start">
                      <div className="custom-text1-secondary-medium">
                        [{`${eventtimezone} - (${curTimezone})`}]
                      </div>
                      <span>
                        {LocaleStrings.note} :-{" "}
                        {LocaleStrings.outreach_form_note1}
                      </span>
                    </div>
                    <div className="outreach-right-content-">
                      <table className="table sponsor-table">
                        <thead>
                          <tr>
                            <th>{LocaleStrings.outreach_table_list_posts}</th>
                            <th>
                              {LocaleStrings.outreach_table_list_linked_with}
                            </th>
                            <th>
                              {LocaleStrings.outreach_table_list_schedule_time}
                            </th>
                            <th>{LocaleStrings.outreach_table_list_status}</th>
                            <th>{LocaleStrings.outreach_table_list_action}</th>
                          </tr>
                        </thead>
                        <tbody className="tbody-background">
                          {this.renderscheduledList()}
                        </tbody>
                      </table>
                    </div>
                    <div className="outreach-right-content-pagination-">
                      {notifcationscheduledList &&
                      notifcationscheduledList.count > itemCount ? (
                        <Pagination
                          activePage={pageNumber}
                          itemsCountPerPage={itemCount}
                          totalItemsCount={notifcationscheduledList.count}
                          pageRangeDisplayed={10}
                          onChange={this.paginationCallback}
                          style={{ float: "right" }}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="nooutreach-info">
                    <span>
                      {LocaleStrings.outreach_text_no_notification_added}
                      <br /> {LocaleStrings.outreach_text_add_to_appear}
                    </span>
                  </div>
                )}
              </Tab>
            </Tabs>
          ) : (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">
                {LocaleStrings.preparingoutreach}
              </div>
            </div>
          )}
        </div>

        {DashboardNotificationModal.show ? (
          <DashboardOutreachCreate
            finishOperationsCallback={this.additionCallback}
            selectedTab={selectedTab}
          />
        ) : (
          ""
        )}

        {/* Notification view modal */}
        {DashboardNotificationViewModal.show ? <DashboardOutreachView /> : ""}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    deviceSize: state.deviceSize,
    session: state.session,
    notifcationList: state.dashboardNotificationList,
    notifcationscheduledList: state.dashboardScheduledNotificationList,
    DashboardNotificationModal: state.DashboardNotificationModal,
    DashboardNotificationViewModal: state.DashboardNotificationViewModal,
    eventDetails: state.userEventDetails,
  };
}

export default connect(mapStateToProps, {
  fetchDashboardNotificationList,
  searchDashboardNotificationList,
  resetPushNotifications,
  outreachCreateModal,
  fetchCategoryWiseUser,
  fetchEventDetails,
})(Outreach);
